import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { GAME_IMAGES } from 'components/GameIcon';
import './GameLink.css';
import '../GameListPage/GameListPage.css';

function GameLink({ game, isMobile, ...otherProps }) {
  // The mobile app requires full page loads when linking to the Tournament play page or the Game play page,
  // because the app has hooks that run special code on those two pages. To account for this, we use a traditional
  // a tag if on mobile instead of react-router's Link.
  const LinkComponent = isMobile ? 'a' : Link;
  const linkParams = isMobile
    ? { href: `/mobile/games/play/${game.name}` }
    : { to: `/game/${game.name}` };

  return (
    <div className="game-link" {...otherProps}>
      <LinkComponent {...linkParams}>
        <img src={GAME_IMAGES[game.name]} alt={game.displayName} />
      </LinkComponent>
    </div>
  );
}

GameLink.propTypes = {
  game: PropTypes.object,
  isMobile: PropTypes.bool
};

export default GameLink;



// WEBPACK FOOTER //
// ./src/containers/GameList/GameLink/index.js